import { useContext, useState } from 'react';
import { WebApiContext } from 'ascendon-web-api';
import { translateFault, generateUnhandledFault } from '../../helpers/faults';

function useCreatePaymentInstrument() {
  const [fault, setFault] = useState(null);
  const [interactionData, setInteractionData] = useState(null);
  const [uiModel, setUiModel] = useState(null);
  const [loading, setLoading] = useState(null);
  const WebApi = useContext(WebApiContext);

  const requestCreatePaymentInstrument = (newRequestData) => {
    setFault(null);
    setLoading(true);
    WebApi.subscriber({
      callName: 'createPaymentInstrument',
      keyFactors: ['createPaymentInstrument'],
      forceRefresh: true,
      payload: newRequestData,
    })
      .then((response) => {
        setLoading(false);
        setUiModel(response.data);
      })
      .catch((error) => {
        setLoading(false);
        console.warn({ error });
        const code = error?.data?.Code;
        const errorMessagesHeading = 1000;
        const unknownError = 1001;
        let errorMsg;
        if (code !== 635) {
          setInteractionData({
            description: 'Web: Create Payment Instrument Failed',
            errorStack: error,
          });
        }
        if (code === 635) {
          setFault({
            Fault: error?.data,
          });
          return;
        }
        const faultCodeGenerate = (data, subCode) => {
          if (data?.Code === 118) {
            return {
              ...data,
              faultCode: `${data?.faultCode}-${subCode}`,
            };
          }
          return { ...data };
        };
        if (!code) {
          const unknownFault = generateUnhandledFault(error.data);
          errorMsg = translateFault(unknownFault).translatedMessage;
          setFault(errorMsg);
        } else {
          setFault('');
          if (error?.data?.Code === 118) {
            errorMsg = `${
              translateFault(
                faultCodeGenerate(error.data, errorMessagesHeading),
              ).translatedMessage
            }-${
              translateFault(faultCodeGenerate(error.data, unknownError))
                .translatedMessage
            }`;
          } else {
            errorMsg = translateFault(error.data).translatedMessage;
          }
          setFault(errorMsg);
        }
      });
  };
  return [
    uiModel,
    fault,
    loading,
    requestCreatePaymentInstrument,
    interactionData,
  ];
}

export { useCreatePaymentInstrument };
export default useCreatePaymentInstrument;
